export default __webpack_public_path__ + "loading-46395d.gif";